<template>
  <div class="ajout">
    <b-form @submit="onSubmitDL" class="d-block forms">
      <h2 class="bold">{{$t($route.meta.title.replace(' - Ooftop','').split(' - ')[1])}}</h2>
      <p class="hight">{{$t("Nouvelle demande")}}</p>
      <div class="container">
        <div class="row">
            <div class="col-md-9 bg-blue">
              <div class="proprietaire mt-3">
                <h3 class="mb-3 bold">{{$t("Propriètaire")}}</h3>
                  <b-form-group :label="$t('Type de propriètaire')" label-for="type">
                    <b-form-radio-group buttons v-model="forms.proprietaire.type" name="type" :options="type_personne" required></b-form-radio-group>
                  </b-form-group>
                  <div class="physique row" v-if="forms.proprietaire.type=='PP'">
                    <div class="col-md-6">
                      <b-form-group label-for="civilite" class="light size-part size-part-2">
                        <template slot="label">{{$t("Civilité")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                        <b-form-radio-group buttons id="civilite" :options="civilites" v-model='forms.proprietaire.civilite'></b-form-radio-group>
                      </b-form-group>
                    </div>
                    <b-form-group :label="$t('Situation familiale')" label-for="situation_familiale" class="col-md-6">
                      <b-form-select id="situation_familiale" :options="situation_familiale" class="form-control" v-model='forms.proprietaire.situation_familiale'></b-form-select>
                    </b-form-group>
                    <b-form-group label-for="nom" class="col-md-6" v-if="forms.proprietaire.civilite==='M'">
                      <template slot="label">{{$t("Nom")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <b-form-input id="nom" class="alphaCheck" v-model='forms.proprietaire.nom' required maxlength="50"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="nom_jf" class="col-md-6" v-if="forms.proprietaire.civilite==='MME'">
                      <template slot="label">{{$t("Nom de jeune fille")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <b-form-input id="nom_jf" class="alphaCheck" v-model='forms.proprietaire.nom_jf' required maxlength="50"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="prenom" class="col-md-6">
                      <template slot="label">{{$t("Prénom")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <b-form-input id="prenom" class="alphaCheck" v-model='forms.proprietaire.prenom' required maxlength="50" @blur="forms.proprietaire.prenom=forms.proprietaire.prenom.normalize('NFD').replace(/[\u0300-\u036f]/gi, '');"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="date_naissance" class="date_naissance col-md-6">
                      <template slot="label">{{$t('Date de naissance')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <b-form-input id="date_naissance" type="text" v-model='forms.proprietaire.date_naissance' required v-mask="'##/##/####'" placeholder="jj/mm/aaaa"></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Pays de naissance')" label-for="pays_naissance" class="col-md-6">
                      <b-form-select id="pays_naissance" :options="pays" class="form-control" v-model='forms.proprietaire.pays_naissance'></b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('Code postal de naissance')" label-for="cp_naissance" class="cpv cp col-md-6" v-if="forms.proprietaire.pays_naissance==='99100'">
                      <autocomplete v-if="forms.proprietaire.cp_naissance===''" :placeholder="$t('Votre code postal')" :source="getDataCPN" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCPN($event,forms.proprietaire)"></autocomplete>
                      <b-form-input v-if="forms.proprietaire.cp_naissance" id="cp_naissance" v-model='forms.proprietaire.cp_naissance' @focus="forms.proprietaire.ci_naissance='';forms.proprietaire.cp_naissance='';forms.proprietaire.ville_naissance='';"></b-form-input>
                      <b-form-input id="ci_naissance" v-model='forms.proprietaire.ci_naissance' class="hidden"></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Ville de naissance')" label-for="ville_naissance" class="cpv ville col-md-6">
                      <autocomplete v-if="forms.proprietaire.ville_naissance==='' && forms.proprietaire.pays_naissance==='99100'" :placeholder="$t('Votre ville')" :source="getDataCPNV" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCPN($event,forms.proprietaire)"></autocomplete>
                      <b-form-input v-if="forms.proprietaire.ville_naissance || forms.proprietaire.pays_naissance!=='99100'" id="ville_naissance" v-model='forms.proprietaire.ville_naissance' @focus="forms.proprietaire.ci_naissance='';forms.proprietaire.cp_naissance='';forms.proprietaire.ville_naissance='';"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="morale row" v-if="forms.proprietaire.type=='PM'">
                    <b-form-group label-for="siren" class="col-md-6">
                      <template slot="label">{{$t("Siren")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <autocomplete v-if="forms.proprietaire.siren.length<9" :placeholder="$t('Votre siren')" :source="getDataSIREN" input-class="form-control numCheck" results-property="data" :resultsFormatter="resultDataSIREN" :results-display="formattedDataSIREN" @selected="addDataSIREN($event,forms.proprietaire)"></autocomplete>
                      <b-form-input v-if="forms.proprietaire.siren.length>8" id="siren" v-model='forms.proprietaire.siren' required></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="nom" class="col-md-6">
                      <template slot="label">{{$t("Nom/Raison sociale")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <b-form-input id="nom" v-model='forms.proprietaire.nom' required maxlength="50"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="adresse" class="col-md-12">
                      <template slot="label">{{$t("Adresse")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <b-form-input id="adresse" v-model='forms.proprietaire.adresse' required maxlength="50"></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Complément')" label-for="complement" class="col-md-12">
                      <b-form-input id="complement" v-model='forms.proprietaire.complement' maxlength="50"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="code_postal" class="cpv cp col-md-4">
                      <template slot="label">{{$t("Code postal")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <autocomplete v-if="forms.proprietaire.code_postal===''" :placeholder="$t('Votre code postal')" required :source="getDataCPN" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCP($event,forms.proprietaire)"></autocomplete>
                      <b-form-input v-if="forms.proprietaire.code_postal" id="code_postal" required v-model='forms.proprietaire.code_postal' @focus="forms.proprietaire.code_postal='';forms.proprietaire.ville='';forms.proprietaire.code_insee='';"></b-form-input>
                      <b-form-input id="code_insee" v-model='forms.proprietaire.code_insee' class="hidden"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="ville" class="cpv ville col-md-4">
                      <template slot="label">{{$t("Ville")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <autocomplete v-if="forms.proprietaire.ville===''" :placeholder="$t('Votre ville')" required :source="getDataCPNV" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCPN($event,forms.proprietaire)"></autocomplete>
                      <b-form-input v-if="forms.proprietaire.ville" id="ville" v-model='forms.proprietaire.ville' @focus="forms.proprietaire.code_postal='';forms.proprietaire.ville='';forms.proprietaire.code_insee='';" required></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Pays')" label-for="pays" class=" col-md-4">
                      <b-form-select id="pays" :options="pays" class="form-control" v-model='forms.proprietaire.pays'></b-form-select>
                    </b-form-group>
                    <a href="javascript:void(0)" class="mt-2 mb-2 btn btn-golg btn-xs bold" @click="forms.proprietaire.show_seconde_adresse=(!forms.proprietaire.show_seconde_adresse)">+ {{$t("Ajouter une seconde adresse connue")}}</a>
                    <b-form-group :label="$t('Seconde adresse')" label-for="seconde_adresse" class="col-md-12" v-if="forms.proprietaire.show_seconde_adresse">
                      <b-form-input id="seconde_adresse" v-model='forms.proprietaire.seconde_adresse'></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="biens mt-3">
                  <h3 class="mb-3 bold">{{$t("Bien immobilier")}}</h3>
                  <b-form-group label-for="adresse">
                    <template slot="label">{{$t("Adresse")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                    <b-form-input id="adresse" v-model='forms.bien.adresse' required maxlength="50"></b-form-input>
                  </b-form-group>
                  <div class="row">
                    <b-form-group label-for="code_postal" class="cpv cp col-md-6">
                      <template slot="label">{{$t("Code postal")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <autocomplete v-if="forms.bien.code_postal===''" :placeholder="$t('Votre code postal')" :source="getDataCPN" required input-class="form-control required" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCP($event,forms.bien)"></autocomplete>
                      <b-form-input v-if="forms.bien.code_postal" id="code_postal" v-model='forms.bien.code_postal' required @focus="forms.bien.code_insee='';forms.bien.code_postal='';forms.bien.ville='';"></b-form-input>
                      <b-form-input id="code_insee" v-model='forms.bien.code_insee' required class="hidden"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="ville" class="cpv ville col-md-6">
                      <template slot="label">{{$t("Ville")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <autocomplete v-if="forms.bien.ville===''" :placeholder="$t('Votre ville')" :source="getDataCPNV" required input-class="form-control required" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCP($event,forms.bien)"></autocomplete>
                      <b-form-input v-if="forms.bien.ville" id="ville" v-model='forms.bien.ville' required @focus="forms.bien.code_insee='';forms.bien.code_postal='';forms.bien.ville='';"></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Référence(s) cadastrale(s)')" label-for="ref_cad" class="mb-3 col-md-12">
                      <div class="refCads mb-1 row" v-for="(ref_cad,irc) in forms.bien.ref_cad" :key="irc">
                        <b-form-group label-for="prefixe" class="col-md-4 pr-1">
                          <template slot="label">{{$t("Préfixe")}}</template>
                          <b-form-input v-model='ref_cad.prefixe' class="numCheck" placeholder="ex : 000, 001" @blur="cpc"></b-form-input>
                        </b-form-group>
                        <b-form-group label-for="section" class="col-md-4 pr-1">
                          <template slot="label">{{$t("Section")}} <sup v-if="ref_cad.prefixe!='' || ref_cad.section!='' || ref_cad.parcelle!='' || ref_cad.contenance!='' || ref_cad.n_lot!=''">{{$t("(champ obligatoire)")}}</sup></template>
                          <b-form-input v-model='ref_cad.section' class="alphaNumCheck" placeholder="ex : A, AV" @blur="cpc"></b-form-input>
                        </b-form-group>
                        <b-form-group label-for="parcelle" class="col-md-4">
                          <template slot="label">{{$t("Numéro de parcelle")}} <sup v-if="ref_cad.prefixe!='' || ref_cad.section!='' || ref_cad.parcelle!='' || ref_cad.contenance!='' || ref_cad.n_lot!=''">{{$t("(champ obligatoire)")}}</sup></template>
                          <b-form-input v-model='ref_cad.parcelle' class="numCheck" placeholder="ex : 250, 10.." @blur="cpc"></b-form-input>
                        </b-form-group>
                        <b-form-group label-for="contenance" class="col-md-4 pr-1">
                          <template slot="label">{{$t("Contenance")}}</template>
                          <b-form-input v-model='ref_cad.contenance' placeholder="ex : 9A56CA" @blur="cpc"></b-form-input>
                        </b-form-group>
                        <b-form-group label-for="n_lot" class="col-md-4 pr-1">
                          <template slot="label">{{$t("Numéro de lot")}}</template>
                          <b-form-input v-model='ref_cad.n_lot' placeholder="ex : 860" @blur="cpc"></b-form-input>
                        </b-form-group>
                        <div class="col-md-4 moreLess">
                          <a href="javascript:void(0)" @click="ajouter_form(forms.bien.ref_cad,'ref_cad_all',0)" v-if="irc===0" class="btn btn-outline-gold noborder mt-3">+ {{$t("Ajouter une référence cadastrale")}}</a>
                          <a href="javascript:void(0)" @click="delete_form(forms.bien.ref_cad,irc)" v-else class="btn btn-outline-gold noborder mt-3">- {{$t("Supprimer cette référence")}}</a>
                        </div>
                      </div>
                    </b-form-group>
                    <b-form-group label-for="type" class="col-md-6">
                      <template slot="label">{{$t("Type de bien")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                      <b-form-select id="type_hab" v-model="forms.bien.type_hab" :options="type_hab" required class="form-control">
                        <template v-slot:first>
                          <b-form-select-option value="" selected disabled>-- {{$t("Veuillez choisir le type de bien")}} --</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('Type d\'occupation')" label-for="precision_type_hab" class="col-md-6 light size-part size-part-3">
                      <b-form-radio-group buttons v-model="forms.bien.precision_type_hab" name="type" :options="type_occupation"></b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Informations complémentaires')" label-for="informations_complementaires" class="col-md-6">
                      <b-form-textarea id="informations_complementaires" v-model="forms.bien.informations_complementaires" placeholder="" rows="7" max-rows="7"  maxlength="900"></b-form-textarea>
                    </b-form-group>
                    <div class="col-md-6">
                      <b-form-group :label="$t('Superficie')" label-for="superficie">
                        <b-form-input id="superficie" v-model='forms.bien.superficie' type="number" :placeholder="$t('Superficie en m²')"></b-form-input>
                      </b-form-group>
                      <b-form-group label-for="pjs">
                        <template slot="label">{{$t("Pièces jointes")}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                        <b-form-file v-model="tmpfile" placeholder="Choisir votre fichier" :drop-placeholder="$t('Déposer votre fichier')" multiple @input="send_file(tmpfile,forms.pjs,'pj');tmpfile=[];"></b-form-file>
                        <div class="badges-pjs mt-3">
                          <b-badge variant="info" class="text-white mr-3 mb-3 py-2 px-2" v-for="(pj,irc) in forms.pjs" :key="irc">{{ pj.name }} <a href="javascript:void(0)" class="ml-2 text-white" @click="delete_form(forms.pjs,irc);" :title="$t('Supprimer')">X</a></b-badge>
                        </div>
                        <p class="mt-3"><small>{{$t("Au moins un de ces documents est nécessaire")}} : {{$t("Acte de vente, état hypothécaire,")}}<br/>{{$t("borderau d'inscription, lettre de mission")}}.<br/><b>{{$t("Format de fichiers autorisés")}}:</b> .txt, .pdf, .doc, .csv, .jpg, .jpeg, .gif, .zip, .docx, .xlsx, .pptx, .tif, .tiff</small></p>
                      </b-form-group>
                    </div>
                  </div>
                  <p class="mb-2"><small>{{$t("loi7817")}}</small></p>
                </div>
            </div>
            <div class="col-md-3">
              <div class="bg-blue">
                <DynField name="reference_client" v-model="forms.reference"></DynField>
                <div class="panier mt-3">
                  <p class="bigText2"><b>{{$t("Tarif")}} : {{ parseInt(panier.total.prix).toFixed(2) }} {{$t("€")}}</b></p>
                </div>
                <br/>
                <b-form-checkbox id="cgv" v-model="cgv_ok" value="1" unchecked-value="0"> {{$t("Je reconnais avoir pris connaissance des")}} <a href="javascript:void(0)" @click="$bvModal.show('modal-cgu')" target="_blank"> {{$t("Conditions Générales de Vente")}}</a> {{$t("de la société")}} {{ infos_cli.societe.label }} {{$t("et les accepter sans réserve")}}.</b-form-checkbox><br/>
                <p>
                  <b-button class="btn-gold" type="button" @click="onSubmitDL" :disabled="loading"><span v-if="loading">{{$t("Enregistrement")}} ...</span><span v-if="!loading">{{$t("Commander")}}</span></b-button>
                </p>
              </div>
            </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import axios from "axios";
  import VueInputMask from 'v-mask';
  import DynField from '@/components/Fields/DynField'
  export default {
      components: { VueInputMask,DynField },
      data() {
        return {
          tmpfile:[],
          yesno:[
            {value:"0",text:this.$i18n.t("Non")},
            {value:"1",text:this.$i18n.t("Oui")}
          ],
          type_personne:[
            {value:"PP",text:this.$i18n.t("Personne physique")},
            {value:"PM",text:this.$i18n.t("Personne morale")}
          ],
          type_bien:[
            {value:"DIRECT",text:this.$i18n.t("Bien direct")},
            {value:"INDIRECT",text:this.$i18n.t("Bien indirect")}
          ],
          type_hab:[
            {value:"Maison",text:this.$i18n.t("Maison")},
            {value:"Appartement",text:this.$i18n.t("Appartement")},
            {value:"Autre",text:this.$i18n.t("Autre")}
          ],
          type_occupation:[
            {value:"Libre",text:this.$i18n.t("Libre")},
            {value:"Locataire",text:this.$i18n.t("Locataire")},
            {value:"Propriètaire",text:this.$i18n.t("Propriètaire")}
          ],
          situation_familiale:[
            {value:"INCONNUE",text:this.$i18n.t("Inconnue")},
            {value:"CELIBATAIRE",text:this.$i18n.t("Célibataire")},
            {value:"MARIE",text:this.$i18n.t("Marié(e)")},
            {value:"DIVORCE",text:this.$i18n.t("Divorcé(e)")},
            {value:"CONCUBINAGE",text:this.$i18n.t("Concubinage")},
            {value:"VEUF",text:this.$i18n.t("Veuf(ve)")},
            {value:"PACSE",text:this.$i18n.t("Pacsé(e)")},
            {value:"SEPARE",text:this.$i18n.t("Séparé(e)")},                
          ],
          civilites:[
            {value:"M",text:this.$i18n.t("Monsieur")},
            {value:"MME",text:this.$i18n.t("Madame")}
          ],
          pays:[],
          infos_cli:{nom:'',societe:[],partner:[]},
          cgv_ok:0,
          forms:{
            reference:'',
            partner:{user_for:'',entite:'',demande_email:1,rapport_email:1,commentaire:''},
            proprietaire:{
              type:'',
              situation_familiale:'',
              civilite:'',
              nom:'',
              nom_jf:'',
              prenom:'',
              date_naissance:'',
              ville_naissance:'',
              cp_naissance:'',
              ci_naissance:'',
              pays_naissance:'99100',
              siren:'',
              adresse:'',
              complement:'',
              code_postal:'',
              code_insee:'',
              ville:'',
              pays:'99100',
              seconde_adresse:'',
              show_seconde_adresse:0,
            },
            bien:{
              type:'',
              adresse:'',
              complement:'',
              code_postal:'',
              code_insee:'',
              ville:'',
              ref_cad:[{
                prefixe:'',
                section:'',
                parcelle:'',
                contenance:'',
                n_lot:'',
              }],
              type_hab:[],
              precision_type_hab:'',
              superficie:'',
              descriptif:'',
              informations_complementaires:'',
            },
            pjs:[]
          },
          panier:{panier:[],nb:[],total:{prix:0}},
          loading:false,
        }
      },
      created(){
        this.get_infos_cli();
      },
      mounted() {
        this.check_price('AVAL',this.forms);
        this.get_pays();
        this.$bvModal.hide('modal-no-estimation');
      },
      methods: {
        onSubmitDL(evt) {
            evt.preventDefault();
            var error=0;
            error=this.check_form(".ajout form");
            if(!this.cgv_ok){this.infosModal('warning',this.$i18n.t("Merci d'accepter les conditions générales de vente."),false,'Informations');}
            else if(this.forms.reference==""){this.infosModal('warning',this.$i18n.t("Merci de remplir la référence du dossier."),false,'Informations');}
            else if(error>0)this.infosModal('warning',this.$i18n.t('Merci de bien vouloir remplir tous les champs suivants correctement avant de valider votre demande : ')+this.errorTxt+'',false,this.$i18n.t('Champs incomplets'));
            else{
              var p=this;
              p.loading=true;
              let formData = new FormData();
              formData.append('datas', JSON.stringify(p.forms));
              axios.post(p.$apiUrl+"demandes/submit/AVAL?lang="+p.$i18n.locale+"&auth="+JSON.stringify(p.auth_header()),formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(function(response){
                if(response.data.error=='notlogged'){
                  p.logout();
                  p.$router.push({ path: '/' });
                }
                else{
                  if (response.data.success) {
                    p.infosModal('success',response.data.success,'avis_valeurs','Confirmation');
                  } else {
                    p.infosModal('warning',response.data.error,false,p.$i18n.t('Champs incomplets'));
                  }
                }
                p.loading = false;
              }).catch(function(error){
                p.loading = false;
              });
            }
        },
        addDataCPN(group,f) {
          f.ci_naissance=group.selectedObject.CODE_INSEE;
          f.cp_naissance=group.selectedObject.CODE_POSTAL;
          f.ville_naissance=group.selectedObject.LABEL;
        },
        addDataCP(group,f) {
          f.code_insee=group.selectedObject.CODE_INSEE;
          f.code_postal=group.selectedObject.CODE_POSTAL;
          f.ville=group.selectedObject.LABEL;
          this.cpc;
        },
        addDataSIREN(group,f) {
          f.siren=group.selectedObject.siret.substr(0,9);
          f.nom=group.selectedObject.name;
          f.adresse=group.selectedObject.address1;
          f.code_postal=group.selectedObject.cp;
          f.ville=group.selectedObject.ville;
          if(group.selectedObject.pays)f.pays=group.selectedObject.pays;
        },
      }
  }
</script>